import { getLink } from "@insite/client-framework/Store/Links/LinksSelectors";

export const filterTabsData = (
    data: any[],
    searchTerm: string,
    tags?: string[] | string,
    state?: any
) => {

    return data.filter(item => {

        let match = true;
        const brandCustomTags = item.generalFields["linkssuppliers"]?.map((itemData: any) => {
            const link = getLink(state, itemData?.fields?.categorysupplier);
            return link?.title?.toLowerCase();
        }) || [];

        if (searchTerm) {
            match = [
                item.fields.title,
                item.fields.newsSummary,
                item.fields.newsContent,
                item.fields.author,
                item.fields.categoryListName,
                item.generalFields?.customTags,
                brandCustomTags.join(","),
            ].some(field =>
                field?.toLowerCase().includes(searchTerm)
            );
        }

        if (!match) return false;
        const customTags =
            item.generalFields?.customTags
                ?.toLowerCase()
                .split(",")
                .map((tag: string) => tag.trim()) || [];

        const allCustomTags = [...customTags, ...(brandCustomTags || [])];

        if (typeof tags === "string" && tags) {
            return allCustomTags.includes(tags);
        }

        if (Array.isArray(tags) && tags.length > 0) {
            return tags.every(tag => allCustomTags.includes(tag));
        }

        return true;
    });
};